<template>
  <div class="d-flex align-center">
    <div class="image-card">
      <v-img
        class="rounded-lg"
        src="https://slide1-images.s3.amazonaws.com/public/relatorio-administrativo/relatório-de-marketing-digital-blog.png"
      ></v-img>
    </div>
    <div class="py-2">
      <v-card-title class="py-0 px-2 title-card">{{
        relatorio.title
      }}</v-card-title>
      <!-- <v-card-text class="py-2 pb-3 px-5">
                    <v-row class="text-card">{{ item.description }}</v-row>
                  </v-card-text> -->
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    relatorio: Object,
  },
};
</script>
<style scoped lang="scss">
.image-card {
  width: 70px;
  height: 70px;
  display: flex;
  padding: 10px;

  .image {
    border-radius: 10px;
  }
}
.title-card {
  font-size: 14px;
  line-height: 1.5;
  word-break: normal;
}
.text-card {
  font-size: 12px;
  color: #797777;
}
</style>
